import { createAuthUserCredential, sendAuthUserVerificationEmail, updateAuthUserProfile } from "../services/authService.js";
import { makeCreateUserCommandFrom } from "@/users/factories/userFactory.js";
import store from '@/vuex/store'
import firebaseTranslator from "@/third-party/firebase/config/firebaseConfig.json";
import { createUser, initiateUser } from "@/users/services/userService.js";
import { captureException } from '@/utils/reporting/reportingService.js'


export default class UserCreationDecorator {
    constructor({ authMethod, attributes }) {
        if (!authMethod.email && !authMethod.authProvider) throw new Error("Provide at least one auth method (email or authProvider)")
        if (!attributes) throw new Error("Provide user attributes for decorator")
        
        if (authMethod.email) {
            if (!authMethod.password) throw new Error("When using email auth method, password is required")
            this.email = authMethod.email;
            this.password = authMethod.password;
        } else {
            this.authProvider = authMethod.authProvider
        }
        this.attributes = attributes
    }

    async create() {
        try {
            if (this.authProvider) throw new Error("User creation with auth provider is not yet supported!")

            const authUser = await this.createAuthUser({ email: this.email, password: this.password })
            const user = await this.createDomainUser(authUser)
            updateAuthUserProfile({ displayName: user.firstName })
            initiateUser({ domainUser: user, authUser: authUser });
            return { success: true, authUser: authUser, user: user }

        } catch (ex) {
            let errMessage
            let expected = false
            if (ex.code) {
                // Excpected errors (E.g email already in user, etc)
                expected = true
                errMessage = firebaseTranslator.responseCodeToFriendlyMessageMap[ex.code]
            } else {
                expected = false
                captureException('UserCreationDecorator.create() > err: ', ex)
                errMessage = "Something went wrong in creating new user, check telemetry..."
            }
            return { success: false, expected: expected, message: errMessage }
        }
    }

    async createAuthUser({ email, password }) {
        const userCredential = await createAuthUserCredential({ email, password })
        sendAuthUserVerificationEmail(userCredential.user)
        return userCredential.user
    }

    async createDomainUser(authUser) {
        try {
            const createUserCommand = this.createNewUserCommand(authUser)
            return await createUser(createUserCommand);
        } catch (ex) {
            console.log("createDomainUser > err: ", ex)
            store.dispatch("deleteAuthUser", authUser); // remove the auth user (e.g firebase user) when user creation fails in business side
            captureException('UserCreationDecorator.createDomainUser() > err: ', ex)
            throw new Error(ex)
        }
    }

    createNewUserCommand(authUser) {
        const createUserCommand = makeCreateUserCommandFrom({
            authUser: authUser,
            fullName: this.attributes.fullName,
            additionalAttributes: this.attributes.additionalAttributes
        })
        if (!createUserCommand) throw new Error("Cannot make createUserCommand")
        return createUserCommand
    }

}







// WEBPACK FOOTER //
// ./src/platform/auth/services/UserCreationDecorator.js